import { getProductList, getProductType, getProductSearch, getProductDetails, getSkuDetails, getBanner, getCartCount, addCart, updateCart, getProductGive } from '@/api/course/index';
import { getDefaultUser } from '@/api/mine/mine';

const mine = {
  state: {
    productList: [],
    productType: [],
    banners: [],
    activePake: localStorage.getItem('activePake') || ''
  },

  mutations: {
    SET_PRODUCT_LIST: (state, data) => {
      state.productList = data;
    },
    SET_PRODUCT_TYPE: (state, data) => {
      state.productType = data;
    },
    SET_BANNER: (state, data) => {
      state.banners = data;
    },
    // 保存活动包信息
    SET_ACTIVITY_PAkE: (state, data) => {
      state.activePake = data;
      localStorage.setItem('activePake', data);
    }
  },

  actions: {
    // 选课首页商品分组列表
    GetProductList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getProductList(data).then(res => {
          commit('SET_PRODUCT_LIST', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 选课首页商品类别列表
    GetProductType({ commit }, data) {
      return new Promise((resolve, reject) => {
        getProductType(data).then(res => {
          commit('SET_PRODUCT_TYPE', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 选课首页 搜索结果
    GetProductSearch({ commit }, data) {
      return new Promise((resolve, reject) => {
        getProductSearch(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 用户默认信息
    GetDefaultUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        getDefaultUser(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 商品详情
    GetProductDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        getProductDetails(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // sku详情
    GetSkuDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        getSkuDetails(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 轮播图
    GetBanner({ commit }, data) {
      return new Promise((resolve, reject) => {
        getBanner(data).then(res => {
          commit('SET_BANNER', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取广告弹出框
    GetCartCount({ commit }) {
      return new Promise((resolve, reject) => {
        getCartCount().then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 新增选课单
    AddCart({ commit }, data) {
      return new Promise((resolve, reject) => {
        addCart(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    UpdateCart({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateCart(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 查询商品赠课列表
    GetProductGive({ commit }, data) {
      return new Promise((resolve, reject) => {
        getProductGive(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default mine;



// WEBPACK FOOTER //
// ./src/store/course.js